export enum AgentStatus {
  Pending = 1,
  Active = 5,
  Suspended = 10,
  Terminated = 15,
  Rejected = 20,
}
